import React from "react";
import Select from 'react-select'
// import {selectThemeColors} from '@utils'
import {Controller} from 'react-hook-form'
import {Label} from 'reactstrap'
import ValidationMsgComponent from "../ValidationMsgComponent";
import "./styles.css"

const ControlledSelect = ({
                              label,
                              inputName,
                              optionsList,
                              invalid,
                              control,
                              isLoading,
                              isSearchable,
                              rules,
                              errors,
                              defaultSelectedValue,
                              isRequired,
                              isMulti,
                              isDisabled,
                              placeholder,
                              isClear,
                              menuPlacement
                          }) => {

    return (
        <div className='mb-1'>
            <Label className='form-label' htmlFor={inputName}>
                {isRequired ? `${label} *` : label}
            </Label>
            <Controller
                name={inputName}
                control={control}
                rules={rules}
                render={({field}) => (
                    <Select
                        id={inputName}
                        // theme={selectThemeColors}
                        className={`react-select ${invalid && 'is-invalid'}`}
                        classNamePrefix='select'
                        options={optionsList}
                        isClearable={isClear}
                        isLoading={isLoading}
                        isSearchable={isSearchable}
                        invalid={invalid}
                        isMulti={isMulti}
                        isDisabled={isDisabled}
                        defaultSelectedValue={defaultSelectedValue}
                        placeholder={placeholder}
                        {...field}
                        menuPlacement={menuPlacement}
                    />

                )}
            />
            {invalid && <ValidationMsgComponent inputName={inputName} invalid={invalid} errors={errors} rules={rules}/>}
        </div>
    )
}

export default ControlledSelect
